"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DriverLicenceSelectField = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = __importDefault(require("react"));
const antd_1 = require("antd");
const DriverLicenceSelect_1 = require("../../global/DriverLicenceSelect");
const DriverLicenceSelectField = ({ name, label, rules, placeholder, listName, listFieldName, getFieldValue, ...otherProps }) => {
    const hasListName = typeof listName === 'number' || typeof listName === 'string';
    const fieldName = hasListName ? [listName, name] : name;
    const isNotSelectedLicence = (chosenDriverLicence) => {
        if (!listFieldName || !hasListName) {
            return true;
        }
        const usedLicences = getFieldValue(listFieldName);
        const actualLicence = getFieldValue([listFieldName, listName]);
        const licencesToFilter = usedLicences.filter(usedLicence => usedLicence && usedLicence.driverLicence !== (actualLicence === null || actualLicence === void 0 ? void 0 : actualLicence.driverLicence));
        if (!licencesToFilter.some(({ driverLicence }) => driverLicence === chosenDriverLicence)) {
            return true;
        }
        return false;
    };
    return ((0, jsx_runtime_1.jsx)(antd_1.Form.Item, { name: fieldName, label: label, rules: rules, children: (0, jsx_runtime_1.jsx)(DriverLicenceSelect_1.DriverLicenceSelect, { placeholder: placeholder, isNotSelectedLicence: isNotSelectedLicence, ...otherProps }) }));
};
exports.DriverLicenceSelectField = DriverLicenceSelectField;
